import { AxiosArgs, ThenArgs, Control } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeQueryParams } from 'src/api/client';

type GetControl = (id: string, query?: { version?: string }) => Promise<AxiosArgs<ThenArgs<AxiosResponse<Control>>>>;

export const getControl: GetControl = (id, query = {}) => {
  const path = `/api/public/api/controls/${id}${encodeQueryParams(query)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};

// ------------------------------------------------------------
